import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";
export const HEADING2_1 = "HEADING2_1";
export const HEADING2_2 = "HEADING2_2";
export const HEADING2_3 = "HEADING2_3";
export const HEADING2_4 = "HEADING2_4";

export const CIRCULAR_GSO_NO = "CIRCULAR_GSO_NO";
export const DOWNLOAD_FILE = "DOWNLOAD_FILE";

export const IT_POLICY = "IT_POLICY";
export const CIRCULAER_1_2020 = "CIRCULAER_1_2020";
export const LOCKDOWN_ORDER = "LOCKDOWN_ORDER";

export const OFFICE_ORDER = "OFFICE_ORDER";
export const DATED = "DATED";

export const translations = {
  en: {
    [HEADING1]: "Letters & Circulars",
    [HEADING2_1]: "Updated Information is published on ksrtc.karnataka.gov.in",
    [HEADING2_2]: "click here",
    [HEADING2_3]: "to View",
    [HEADING2_4]: "NEW",
    [CIRCULAR_GSO_NO]: "Circular/GSO No",
    [DOWNLOAD_FILE]: "Download File",
    [IT_POLICY]: "IT Policy",
    [CIRCULAER_1_2020]: "Circular 1/2020",
    [LOCKDOWN_ORDER]: "7 day lockdown order",
    [OFFICE_ORDER]: "Office Order",
    [DATED]: "Dated",
  },
  kn: {
    [HEADING1]: "ಪತ್ರಗಳು ಮತ್ತು ಸುತ್ತೋಲೆಗಳು",

    [HEADING2_1]:
      "ಅಪ್‌ಡೇಟ್ ಮಾಡಿದ ಮಾಹಿತಿಯನ್ನು ksrtc.karnataka.gov.in ನಲ್ಲಿ ಪ್ರಕಟಿಸಲಾಗಿದೆ",
    [HEADING2_2]: "ಹೊಸ",
    [HEADING2_3]: "ದನ್ನು ವೀಕ್ಷಿಸಲು",
    [HEADING2_4]: "ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    [CIRCULAR_GSO_NO]: "ಸುತ್ತೋಲೆ/GSO ಸಂ",
    [DOWNLOAD_FILE]: "ಫೈಲ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    [IT_POLICY]: "ಐಟಿ ನೀತಿ",
    [CIRCULAER_1_2020]: "ಸುತ್ತೋಲೆ 1/2020",
    [LOCKDOWN_ORDER]: "7 ದಿನಗಳ ಲಾಕ್‌ಡೌನ್ ಆರ್ಡರ್",
    [OFFICE_ORDER]: "ಕಛೇರಿ ಆರ್ಡರ್",
    [DATED]: "ದಿನಾಂಕ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
